/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveMissingInfoFollowUpSendRequest
 */
export interface ResolveMissingInfoFollowUpSendRequest {
    /**
     * 
     */
    attempt_id: string;
    /**
     * 
     */
    resolution: ResolveMissingInfoFollowUpSendRequestResolutionEnum;
}


/**
 * @export
 */
export const ResolveMissingInfoFollowUpSendRequestResolutionEnum = {
    ConfirmSent: 'confirm_sent',
    ReturnToDraft: 'return_to_draft',
} as const;
export type ResolveMissingInfoFollowUpSendRequestResolutionEnum = typeof ResolveMissingInfoFollowUpSendRequestResolutionEnum[keyof typeof ResolveMissingInfoFollowUpSendRequestResolutionEnum];


/**
 * Check if a given object implements the ResolveMissingInfoFollowUpSendRequest interface.
 */
export function instanceOfResolveMissingInfoFollowUpSendRequest(value: object): value is ResolveMissingInfoFollowUpSendRequest {
    if (!('attempt_id' in value) || value['attempt_id'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    return true;
}

export function ResolveMissingInfoFollowUpSendRequestFromJSON(json: any): ResolveMissingInfoFollowUpSendRequest {
    return ResolveMissingInfoFollowUpSendRequestFromJSONTyped(json, false);
}

export function ResolveMissingInfoFollowUpSendRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveMissingInfoFollowUpSendRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attempt_id': json['attempt_id'],
        'resolution': json['resolution'],
    };
}

export function ResolveMissingInfoFollowUpSendRequestToJSON(json: any): ResolveMissingInfoFollowUpSendRequest {
    return ResolveMissingInfoFollowUpSendRequestToJSONTyped(json, false);
}

export function ResolveMissingInfoFollowUpSendRequestToJSONTyped(value?: ResolveMissingInfoFollowUpSendRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempt_id': value['attempt_id'],
        'resolution': value['resolution'],
    };
}

